const styles = {
  noResults: {
    textAlign: 'center',
    marginTop: '20px;'
  }
}

export default styles;